// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"9371530a","453":"5e1f698f","777":"722ce3a9"}[chunkId] + ".chunk.js";
};